import {ValueObject} from '@s-ui/domain'

export class GetLoanUrlTransactionsRequest extends ValueObject {
  /**
   * @param {Object} data
   **/
}
